export enum DefinitionStep {
  DEFINE_PRODUCT = 'DEFINE_PRODUCT',
  DEFINE_BRAND = 'DEFINE_BRAND',
  DEFINE_CATEGORY = 'DEFINE_CATEGORY',
  DEFINE_FORM = 'DEFINE_FORM',
}
